import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Navbar } from "../components/site/Navbar";
import { Footer } from "../components/site/Footer";
import { Reveal } from "../components/site/Reveal";
import { EnquiryForm, CATEGORIES } from "../components/site/EnquiryForm";
import { api } from "../lib/api";
import { useTitle } from "../App";

export default function Contact() {
  useTitle("Contact");
  const [params] = useSearchParams();
  const [config, setConfig] = useState({});
  const category = params.get("category") || "";
  const valid = CATEGORIES.some((c) => c.value === category) ? category : "";

  useEffect(() => {
    api.get("/content/config").then((r) => setConfig(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="contact-page" className="bg-midnight text-mist">
      <Navbar />
      <section className="grain pt-[76px]">
        <div className="container-ek grid gap-14 py-24 sm:py-28 lg:grid-cols-12">
          <Reveal className="lg:col-span-5">
            <p className="eyebrow mb-4">Contact</p>
            <h1 className="font-display text-4xl font-bold tracking-tight sm:text-6xl">Let's make your next move meaningful.</h1>
            <p className="mt-6 max-w-md text-base leading-relaxed text-slate-400">
              Every enquiry is saved to our system, read personally and answered with a considered reply — usually within two working days.
            </p>
            <div className="mt-10 space-y-5 text-sm text-slate-400">
              <div>
                <p className="font-mono text-[10px] uppercase tracking-widest text-slate-500">Business, partnerships &amp; commercial</p>
                <a data-testid="contact-business-email" href="mailto:business@ekavrixtech.com" className="mt-1 inline-block text-teal transition-colors hover:text-teal-hover">business@ekavrixtech.com</a>
              </div>
              <div>
                <p className="font-mono text-[10px] uppercase tracking-widest text-slate-500">Help, support &amp; general queries</p>
                <a data-testid="contact-helpdesk-email" href="mailto:helpdesk@ekavrixtech.com" className="mt-1 inline-block text-teal transition-colors hover:text-teal-hover">helpdesk@ekavrixtech.com</a>
              </div>
              <p className="max-w-sm leading-relaxed text-slate-500">
                Prefer a call? Mention your preferred times in the message and we will schedule one — no meeting is booked until we confirm it with you directly.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.12} className="lg:col-span-7">
            <div className="card-dark p-7 sm:p-10">
              <EnquiryForm title="Send your enquiry" defaultCategory={valid} sourcePage="/contact" />
            </div>
          </Reveal>
        </div>
      </section>
      <Footer />
    </div>
  );
}
